var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M16.444 4h-5.333a3.566 3.566 0 0 0-3.555 3.556A3.566 3.566 0 0 0 4 11.11v5.333C4 18.4 5.6 20 7.556 20h5.333c1.955 0 3.555-1.6 3.555-3.556 1.956 0 3.556-1.6 3.556-3.555V7.556C20 5.6 18.4 4 16.444 4m-1.777 12.444c0 .978-.8 1.778-1.778 1.778H7.556c-.978 0-1.778-.8-1.778-1.778v-5.333c0-.978.8-1.778 1.778-1.778h5.333c.978 0 1.778.8 1.778 1.778v5.333m3.555-3.555c0 .978-.8 1.778-1.778 1.778V11.11c0-1.955-1.6-3.555-3.555-3.555H9.333c0-.978.8-1.778 1.778-1.778h5.333c.978 0 1.778.8 1.778 1.778z"
  })));
};
export default SvgIconCopy;